export default "__VITE_ASSET__FM_Fefk3__"